export const LANGUAGE_ACCOUNT_LOCK_STORAGE_KEY = 'fideprep:languageAccountLock';
export const LANGUAGE_ACCOUNT_LOCK_CUSTOM_EVENT = 'fideprep:languageAccountLock';
export const LANGUAGE_ACCOUNT_LOCK_REASON_MOCK_EXAM_STARTED = 'mock_exam_started';

const getLocalStorage = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window.localStorage;
  } catch (_) {
    return null;
  }
};

const normalizeLanguageAccountLockPayload = (value) => {
  const rawValue =
    typeof value === 'string'
      ? (() => {
          try {
            return JSON.parse(value);
          } catch (_) {
            return null;
          }
        })()
      : value;

  if (!rawValue || typeof rawValue !== 'object') {
    return null;
  }

  const uid = typeof rawValue.uid === 'string' ? rawValue.uid.trim() : '';
  const reason =
    rawValue.reason === LANGUAGE_ACCOUNT_LOCK_REASON_MOCK_EXAM_STARTED
      ? LANGUAGE_ACCOUNT_LOCK_REASON_MOCK_EXAM_STARTED
      : null;
  const numericTimestamp = Number(rawValue.at);
  const at = Number.isFinite(numericTimestamp) ? numericTimestamp : Date.now();

  if (!uid || !reason) {
    return null;
  }

  return {
    uid,
    reason,
    at,
  };
};

const publishMockExamLanguageLock = (uid) => {
  const normalizedPayload = normalizeLanguageAccountLockPayload({
    uid,
    reason: LANGUAGE_ACCOUNT_LOCK_REASON_MOCK_EXAM_STARTED,
    at: Date.now(),
  });

  if (!normalizedPayload) {
    return null;
  }

  const storage = getLocalStorage();
  if (storage) {
    storage.setItem(LANGUAGE_ACCOUNT_LOCK_STORAGE_KEY, JSON.stringify(normalizedPayload));
  }

  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
    window.dispatchEvent(
      new CustomEvent(LANGUAGE_ACCOUNT_LOCK_CUSTOM_EVENT, {
        detail: normalizedPayload,
      }),
    );
  }

  return normalizedPayload;
};

export { normalizeLanguageAccountLockPayload, publishMockExamLanguageLock };
